import React from 'react';
import { useLazyCommand } from "@soap/modules";
import { Button } from '../../ui/button';
import { Card } from '../../ui/card';

export function RemoveSectionDialog({ 
  assessmentId, 
  sectionId, 
  sectionTitle, 
  onClose 
}: { 
  assessmentId: string; 
  sectionId: string; 
  sectionTitle: string;
  onClose: () => void;
}) {
  const [removeSectionTrigger] = useLazyCommand("C191v1_RemoveAssessmentSection");

  const handleRemove = () => {
    removeSectionTrigger({
      C191_AssessmentId: assessmentId,
      C191_SectionId: sectionId,
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-full max-w-md p-6 m-4">
        <h3 className="text-lg font-semibold mb-4">Remove Section</h3>
        <p className="mb-2">Please confirm you want to remove the section "{sectionTitle}"?</p>
        <p className="text-sm text-gray-600 mb-4">This will not remove the section from any previously shared assessments.</p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button variant="destructive" onClick={handleRemove}>Remove</Button>
        </div>
      </Card>
    </div>
  );
}

